module.exports = __webpack_public_path__ + "images/emoji/bulb.92200e0a6c7311a9d456.png";